import { render, staticRenderFns } from "./Menu3.vue?vue&type=template&id=16d266aa&scoped=true&"
import script from "./Menu3.vue?vue&type=script&lang=js&"
export * from "./Menu3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d266aa",
  null
  
)

export default component.exports